import { HttpErrorResponse, HttpInterceptorFn } from '@angular/common/http';
import { catchError, finalize, throwError } from 'rxjs';
import { inject } from '@angular/core';
import { DialogService } from '../_services/dialog.service';
import { ErrorToastComponent } from '../_widgets/error-toast/error-toast.component';
import { MatSnackBarRef } from '@angular/material/snack-bar';

let snackBarRef: MatSnackBarRef<ErrorToastComponent>;

export const errorInterceptor: HttpInterceptorFn = (req, next) => {
  const dialogService = inject(DialogService);

  return next(req).pipe(
    catchError((err) => {
      if (!snackBarRef && req.responseType !== 'text') {
        console.error(err);
        snackBarRef = dialogService.onError(err);
      }

      return throwError(() => err);
    })
  );
};
